import React, {useMemo} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import EmptyStepperLineSingleVoyage
    from "@containers/singleVoyage/views/stepperLine/emptyStepperLine/EmptyStepperLineSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";

const PointListMiniModeMutateSingleVoyage = () => {

    const {
        points,
        setTargetPointId,
    } = useRootContextMutateSingleVoyage()

    const {setModeSecondarySidebar} = useViewContextMutateSingleVoyage()


    const steps = useMemo(() => {
        if (!points?.length) {
            return []
        }
        return points.map((point, index) => {
            return {
                onClick: () => {
                    setTargetPointId(point.id?.toString())
                    setModeSecondarySidebar('point')
                }
            }
        })
    }, [points])

    return (
        <EmptyStepperLineSingleVoyage
            steps={steps}
        />

    );
};

export default PointListMiniModeMutateSingleVoyage;
